import { PublicKey } from "@solana/web3.js";

export const USDC_MINT = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const WRAPPED_SOL_MINT = "So11111111111111111111111111111111111111112";
export const STAKED_SOL_MINT = "sTSoN7tYft63PJjHw2NcgJ43saq3NiE3XCdfvXXcTrD";
export const JLP_MINT = "27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4";
export const DEFAULT_PUBLIC_KEY = PublicKey.default.toString();
export const SOL_NATIVE_MINT = DEFAULT_PUBLIC_KEY;

export const USDC_SYMBOL = "USDC";
export const SOL_SYMBOL = "SOL";
export const RECOMMENDED_TXN_FEE = "0.001";

export const DEFAULT_PRINCIPAL_MINT = USDC_MINT;
export const DEFAULT_TXN_FEE = 0.000015;
export const SOL_DECIMALS = 9;
export const PERCENT_DECIMALS = 3;

export const MIN_SOL_BALANCE = 0.06;
export const RECOMMENDED_SOL_BALANCE = 0.04;

export const BASE_FEE_LAMPORTS = 5000;

export const DISABLED_APY = "18446744073709551615";
